module.exports = require('./helpers/bundle-url').getBundleURL('dUqIU') + "logo-dark.eefe0b7f.svg";